import { Component, Inject } from "@angular/core";
import { Router, ActivatedRoute, Params } from "@angular/router";
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { UserService } from "../../../services/user.service";
import { CompanylinkedService } from "../../../services/companylinked.service";
import { CompanyLinked } from "../../../models/companylinked";
import { LocationService } from "../../../services/location.service";
import { User } from "../../../models/user";
import { Methods } from "../../../shared/methods";
import { NuevoCompany } from "../../../tables/listcompany/listcompany.component";
import { VendorService } from "../../../services/vendor.service";
import { Folder } from "src/app/models/folder";
import { FolderService } from "../../../services/folder.service";
import swal from "sweetalert2";
import { TaxService } from "../../../services/tax.service";
import { Observable, of } from "rxjs";
import { map, startWith } from "rxjs/operators";
import { FormControl } from "@angular/forms";

export interface UserList {
  value: string;
  name: string;
}
@Component({
  selector: "app-vendor",
  templateUrl: "./vendor.component.html",
  styleUrls: ["./vendor.component.css"],
  providers: [UserService, CompanylinkedService, LocationService],
})
export class VendorComponent {
  public mtds: Methods = new Methods();
  public identity;
  public token;
  public user: User = new User();
  public status_user;
  public privilegio;
  public companySelected = "";
  public companies;
  public company;
  public companyLocations: any[] = [];
  public repsList: any[] = [];
  public countries;
  public states = [];
  public country_id;
  filteredCountries: Observable<UserList[]>;
  filteredStates: Observable<UserList[]>;
  myControlCountries = new FormControl();
  myControlStates = new FormControl();

  private _filterCountries(name: string): UserList[] {
    const filterValue = name;

    return this.countries.filter((option) =>
      String(option.name).toLowerCase().startsWith(filterValue)
    );
  }

  private _filterStates(name: string): UserList[] {
    const filterValue = name;

    return this.states?.filter((option) =>
      String(option.name).toLowerCase().startsWith(filterValue)
    );
  }
  sexos = [
    { value: "0", viewValue: "Female" },
    { value: "1", viewValue: "Male" },
    { value: "2", viewValue: "Other" },
  ];

  frequencies = [
    { value: "DAILY", viewValue: "Daily" },
    { value: "WEEKLY", viewValue: "Weekly" },
    { value: "MONTHLY", viewValue: "Monthly" },
    { value: "NEVER", viewValue: "Never" },
  ];

  cities = [
    { value: "paris-0", viewValue: "Paris" },
    { value: "miami-1", viewValue: "Miami" },
    { value: "bucharest-2", viewValue: "Bucharest" },
    { value: "new-york-3", viewValue: "New York" },
    { value: "london-4", viewValue: "London" },
    { value: "barcelona-5", viewValue: "Barcelona" },
    { value: "moscow-6", viewValue: "Moscow" },
  ];

  public companyName = "";
  public loadingReps = false;

  constructor(
    private _service: VendorService,
    private _folderService: FolderService,
    public dialogRef: MatDialogRef<VendorComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _userService: UserService,
    private _companylinkedService: CompanylinkedService,
    private _route: ActivatedRoute,
    private _locationService: LocationService,
    private _router: Router,
    public dialog: MatDialog,
    private _taxService: TaxService
  ) {
    console.log(data);
    this.privilegio = JSON.parse(localStorage.getItem("privilegio"));
    this.identity = this._userService.getIdentity();
    data.user.user_id = this.identity.sub;
    this.token = this._userService.getToken();

    this.getAllCompanies();
    this.getReps();
  }
  ngOnInit() {
    console.log("este es mi vendor", this.data);
    if (this.identity == null && this.identity.sub) {
      this._router.navigate(["/pages/lock"]);
    }
    this.myControlCountries.disable();
    this.myControlStates.disable();
    this.getCountries();
  }

  getReps() {
    this.loadingReps = true;
    this._userService.getAllReps(this.token).subscribe((r) => {
      this.repsList = r.data.map((e) => {
        return { id: e.id, name: `${e.name} ${e.surname}` };
      });
      // this.repsList.push({id: 4, name: 'Admin Admin'});
      // console.log(this.repsList);
      this.loadingReps = false;
    });
  }

  getAllCompanies() {
    this._companylinkedService.getAllCompaniesLite(this.token, "all").subscribe(
      (response) => {
        if (response.status == "success") {
          this.companies = response.data;
          if (this.data.company) {
            this.changeCompany({ value: this.data.company });
          }
        }
      },
      (error) => {
        console.log(<any>error);
      }
    );
  }

  getCompanyLocations(company_id) {
    this._locationService
      .getLocationsByCompany(this.token, company_id)
      .subscribe((r) => {
        console.log(r);
        this.companyLocations = r.data;
      });
  }

  changeLocation() {
    if (this.data.user.locationId === "null") {
      this.data.user.locationId = null;
    }
    this.getCountries(false); // <-- pasamos bandera opcional

    this.data.user.typeLocationSelected = "Headquarter";
    this.myControlCountries.disable();
    this.myControlStates.disable();

    let flat = false;

    if (this.data.user.locationId != null && this.data.user.locationId != 0) {
      for (let loc of this.companyLocations) {
        if (this.data.user.locationId == loc.id) {
          this.myControlCountries.disable();
          this.myControlStates.disable();
          this.myControlCountries.setValue(loc.country);
          this.myControlStates.setValue(loc.colonia);
          this.data.user.address = loc.address;
          this.data.user.address2 = loc.address2;
          this.data.user.country = loc.country;
          this.data.user.colonia = loc.colonia;
          this.data.user.city = loc.city;
          this.data.user.zipCode = loc.zipCode;
          this.data.user.phone = loc.phone;
          flat = true;
          break;
        }
      }
      this.data.user.typeLocationSelected = "Location";
    } else if (this.data.user.locationId == 0) {
      // Primero limpiar datos
      this.data.user.typeLocationSelected = "Blank";
      this.data.user.address = "";
      this.data.user.address2 = "";
      this.data.user.country = "";
      this.data.user.colonia = "";
      this.data.user.city = "";
      this.data.user.zipCode = "";
      this.myControlCountries.setValue("");
      this.myControlStates.setValue("");
      // Luego obtener países y activar autocomplete
      this.getCountries(true); // <-- pasamos bandera opcional

      flat = true;
    }

    if (!flat && this.companyLinked) {
      this.data.user.address = this.companyLinked.address;
      this.data.user.address2 = this.companyLinked.address2;
      this.data.user.country = this.companyLinked.country;
      this.data.user.colonia = this.companyLinked.colonia;
      this.data.user.city = this.companyLinked.city;
      this.data.user.zipCode = this.companyLinked.zipCode;
      this.data.user.phone = this.companyLinked.phone;
      this.myControlCountries.setValue(this.companyLinked.country);
      this.myControlStates.setValue(this.companyLinked.colonia);
    }
  }

  openNuevoCompany(): void {
    this.company = new CompanyLinked(
      1,
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      1,
      0,
      "",
      "",
      "",
      "",
      "",
      0,
      0,
      0,
      0
    );
    let dialogRef = this.dialog.open(NuevoCompany, {
      width: "80%",
      data: { user: this.company },
    });

    dialogRef.afterClosed().subscribe((result) => {
      console.log(result);
      this._companylinkedService.create(this.token, result).subscribe(
        (response) => {
          console.log(response);
          this.status_user = response.status;

          if (this.status_user != "success") {
            this.status_user = "error";
          } else {
            this.getAllCompanies();
            this.companySelected = response.company.id;
            this.data.user.companyLinked = {
              id: this.companySelected,
            };
          }
        },
        (error) => {
          console.log(<any>error);
        }
      );
    });
  }

  public companyLinked = null;

  changeCompany(e) {
    // console.log(e);
    if (e.value) {
      this.companySelected = e.value;

      this.data.user.companyLinked = {
        id: this.companySelected,
      };
      console.log(this.data.user.companyLinked);
      this._companylinkedService
        .getCompany(this.token, this.companySelected)
        .subscribe(
          (response) => {
            console.log(response.data);
            this.companyName = response.data.name;
            this.data.user.address = response.data.address;
            this.data.user.address2 = response.data.address2;
            this.data.user.city = response.data.city;
            this.data.user.colonia = response.data.colonia;
            this.data.user.zipCode = response.data.zipCode;
            this.data.user.country = response.data.country;
            this.data.user.phone = response.data.phone;
            this.data.user.mobilePhone = response.data.mobilePhone;
            this.myControlCountries.setValue(response.data.country);
            this.myControlStates.setValue(response.data.colonia);
            this.getCountries();

            this.companyLinked = response.data;
            // this.data.user.locationId = null;
            this.getCompanyLocations(this.companyLinked.id);
          },
          (error) => {
            this.mtds.notifyError(error.statusText, error.status);
            console.log(<any>error);
          }
        );
    }
  }

  public loadingCountries = false;
  public loadingStates = false;

  displayCountry(country: any): string {
    return country?.name || "";
  }

  displayState(state: any): string {
    return state ? `${state.abbr} - ${state.name}` : "";
  }
  onStateSelected(state: any) {
    console.log("stateee", state);
    this.data.user.colonia = state.abbr;
  }
  getCountries(triggerAutocompleteFromBlank = false) {
    this._taxService.getCountries().subscribe((r) => {
      this.loadingCountries = true;
      if (r.status == "success") {
        this.loadingCountries = false;
        this.countries = r.data;

        this.filteredCountries = this.myControlCountries.valueChanges.pipe(
          startWith<string | UserList>(""),
          map((value) =>
            typeof value === "string" ? value : value?.name ?? ""
          ),
          map((name) =>
            name ? this._filterCountries(name) : this.countries.slice()
          )
        );

        // Si fue llamado desde "blank"
        if (triggerAutocompleteFromBlank) {
          this.myControlCountries.enable();
          this.myControlStates.enable();
          this.myControlCountries.setValue("");
          this.myControlStates.setValue("");
        }

        // Si viene ya con un país seteado
        if (this.data.user && !triggerAutocompleteFromBlank) {
          const foundCountry = this.countries.find(
            (c) => c.name === this.formatName(this.data.user.country)
          );
          if (foundCountry) {
            this.myControlCountries.setValue(foundCountry);
          }
          this.getStates(foundCountry?.name);
        }
      }
    });
  }
  onCountrySelected(country: any) {
    this.data.user.country = country.name;
    console.log("País seleccionado:", country);
    this.getStates(this.data.user.country);
  }
  getStates(countryName) {
    console.log("countryname", countryName);
    let country_id = null;
    for (let country of this.countries) {
      if (country.name == countryName) {
        country_id = country.id;
        break;
      }
    }
    console.log("country id", country_id);
    this._taxService.showAll(country_id).subscribe(
      (r) => {
        console.log(r.data, "states");
        this.states = r.data;
        const coloniaAbbr = this.data.user.colonia?.split(" - ")[0]; // Extrae sólo "TX"
        const foundState = this.states.find((c) => c.abbr === coloniaAbbr);

        this.filteredStates = this.myControlStates.valueChanges.pipe(
          startWith<string | UserList>(""),
          map((value) => (typeof value === "string" ? value : value.name)),
          map((name) => (name ? this._filterStates(name) : this.states.slice()))
        );
        if (foundState) {
          this.myControlStates.setValue(foundState);
        }

        console.log("jala los states", this.states);
        this.loadingStates = false;
      },
      (error) => {
        this.loadingStates = false;
      }
    );
  }
  formatName(name: string): string {
    if (!name) return "";
    return name
      .toLowerCase()
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  }
  get isDisabledFirstStep(): boolean {
    return (
      !this.companyName ||
      !this.data.user.name ||
      !this.data.user.surname ||
      !this.data.user.email
    );
  }
  // get completedFirstStep(): boolean {
  //   return this.data.user.companyId && this.data.user.name;
  // }
  showToast(type, title, timer) {
    const Toast = swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: timer,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.onmouseenter = swal.stopTimer;
        toast.onmouseleave = swal.resumeTimer;
      },
    });
    Toast.fire({
      icon: type,
      title: title,
    });
  }
  get isDisabledSecondStep(): boolean {
    return (
      !this.data.user.address ||
      !this.data.user.country ||
      !this.data.user.colonia ||
      !this.data.user.city ||
      !this.data.user.zipCode ||
      !this.data.user.phone
    );
  }
  onSubmit() {
    console.log(this.data.user, "userrrrr");
    this._service.newVendor(this.data.user).subscribe(
      (response: any) => {
        console.log(response, "resaqui");

        if (response.status === "success") {
          let userid = {
            name: "mad",
            value: response.user.id,
          };

          if (response.hasfolder == null) {
            let folderNEw = new Folder(
              1,
              response.user.companyLinked.name,
              "",
              "",
              userid,
              "",
              0,
              0,
              1,
              0
            );
            console.log(folderNEw, "folder");
            this._folderService
              .create(JSON.parse(localStorage.getItem("token")), folderNEw)
              .subscribe(
                (response) => {
                  console.log(response);
                },
                (error) => {
                  console.log(<any>error);
                }
              );
          }

          this.dialogRef.close();
          this.showToast("success", "Vendor successfully added!", 2000);
        } else {
          if (response.msg === "User already exist") {
            this.showToast("error", "Error! User already exist", 2000);
          } else {
            this.showToast(
              "error",
              "Error! Something went wrong, it was not possible to add the user",
              2000
            );
            this.dialogRef.close();
          }
        }
      },
      (error) => {
        console.log(<any>error);
      }
    );
    /* this._userService.create(this.token, this.user).subscribe(
         response => {
           console.log(response);
           this.status_user = response.status;
 
           if(this.status_user != 'success'){
             this.status_user = 'error';
           } else {
             this.user = response.data;
             //this._router.navigate(['/task', this.task.id]);
            this.dialogRef.close();
            return this.user;
           }
         },
         error => {
           console.log(<any>error);
         }
       );*/
  }

  onNoClick(): void {}
}
